import React, { useEffect, useState } from 'react';
import { fetchSchoolsForExport, EXPORT_SCHOOL_CHANGED } from '../../../utils/exportSchoolFilter';

// Narrows every metric card -- both its count and its download -- to one school.
// Blank is "all schools", the normal production run; picking one school is how a
// change gets tried on a batch small enough to check by hand before it ships to
// everybody.
//
// A plain <select id="export_school_id"> on purpose: the export controls beside
// it are read out of the DOM by id, and this is one more of them. No Bootstrap
// .form-control -- that is width:100% !important app-wide (dprojects.scss) and
// would stretch the control across the whole bar.
const ExportSchoolFilter = () => {
  const [schools, setSchools] = useState([]);
  const [failed, setFailed] = useState(false);
  // The list is built by a background worker, so a cold load waits. Saying so
  // matters: while loading, this control used to look exactly like a loaded one
  // with no schools in it, and an operator could not tell "still coming" from
  // "broken" -- which is how a 60s timeout read as an empty dropdown.
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    fetchSchoolsForExport()
      .then((data) => { if (active) { setSchools(data); setLoading(false); } })
      .catch(() => { if (active) { setFailed(true); setLoading(false); } });

    return () => { active = false; };
  }, []);

  // The cards are three separate React roots, so there is no shared parent to
  // hold this. A DOM event is the least machinery that keeps their counts in
  // step with the selection.
  const handleChange = (event) => {
    document.dispatchEvent(
      new CustomEvent(EXPORT_SCHOOL_CHANGED, { detail: { schoolId: event.target.value } }),
    );
  };

  return (
    <div>
      <label htmlFor="export_school_id" style={{ display: 'block', marginBottom: '4px' }}>
        School
      </label>
      <select
        id="export_school_id"
        onChange={handleChange}
        disabled={failed || loading}
        style={{ minWidth: '280px', maxWidth: '380px', height: '34px' }}
      >
        <option value="">{loading ? 'Loading schools…' : 'All schools'}</option>
        {schools.map((school) => (
          <option key={school.value} value={school.value}>{school.label}</option>
        ))}
      </select>
      <br />
      <small className="text-muted">
        {failed && 'School list unavailable — exports will cover all schools.'}
        {loading && 'Building the school list — this takes a moment on the first load.'}
        {!failed && !loading && 'Applies to the metric cards below, count and download alike.'}
      </small>
    </div>
  );
};

export default ExportSchoolFilter;
